module.exports = __webpack_public_path__ + "img/3-4.27623be1.svg";